<div
  class="ui-welcome-panel"
  [class.ui-welcome-panel--sidebar-collapsed]="sidebarCollapsed()"
  [class.ui-welcome-panel--without-menubar]="!showMenubar()"
>
  <div class="ui-welcome-panel__header" role="banner">
    <ui-app-header
      [logoSrc]="logoSrc()"
      [logoAlt]="logoAlt()"
      [navTitle]="navTitle()"
      [showHome]="showHome()"
      [showCompanyFilter]="showHeaderSelector()"
      [showMessages]="showMessages()"
      [messageCount]="messageCount()"
      [notificationCount]="notificationCount()"
      [showMenuToggle]="true"
      [userAvatarLabel]="userAvatarLabel()"
      [profileUserName]="profileUserName()"
      [profileUserRole]="profileUserRole()"
      [profileUserEmail]="profileUserEmail()"
      [profileMenuItems]="profileMenuItems()"
      menuToggleTooltip=""
      (menuToggleClick)="sidebarToggle.emit()"
      (homeClick)="homeClick.emit()"
      (logoutClick)="logoutClick.emit()"
    >
      <ng-container ngProjectAs="[data-ui-app-header-nav]">
        <ng-content select="[data-ui-app-header-nav]" />
      </ng-container>
      <ng-container ngProjectAs="[data-ui-app-header-end-start]">
        <ng-content select="[data-ui-app-header-end-start]" />
      </ng-container>
    </ui-app-header>
  </div>

  <aside class="ui-welcome-panel__sidebar">
    <ui-app-sidebar
      [items]="sidebarItems()"
      [selectedValue]="sidebarSelectedValue()"
      [collapsed]="sidebarCollapsed()"
      [ariaLabel]="sidebarAriaLabel()"
      (itemSelect)="sidebarItemSelect.emit($event)"
    />
  </aside>

  @if (showMenubar()) {
    <div
      class="ui-welcome-panel__menubar"
      role="navigation"
      [attr.aria-label]="menubarAriaLabel()"
    >
      <ui-menubar
        [items]="menubarItems()"
        [ariaLabel]="menubarAriaLabel()"
        (itemSelect)="menubarItemSelect.emit($event)"
      >
        <ng-content select="[data-ui-menubar-start]" />
        <ng-content select="[data-ui-menubar-end]" />
      </ui-menubar>
    </div>
  }

  <main class="ui-welcome-panel__main" [attr.aria-label]="mainLabel()">
    @if (showTitleBar()) {
      <ui-title-bar
        [mode]="titleBarMode()"
        [title]="title()"
        [breadcrumbItems]="breadcrumbItems()"
        [breadcrumbHome]="breadcrumbHome()"
        [breadcrumbAriaLabel]="breadcrumbAriaLabel()"
      >
        <ng-content select="[slot-title-bar-end]" />
      </ui-title-bar>
    }

    <div class="ui-welcome-panel__below-title-bar">
      <ng-content select="[slot-below-title-bar]" />
    </div>

    <div class="ui-welcome-panel__content">
    <ng-content select="[slot-center]" />
    </div>
  </main>
</div>
